import { render } from "./ItemPickZones.vue?vue&type=template&id=486efd3e&scoped=true"
import script from "./ItemPickZones.vue?vue&type=script&lang=js"
export * from "./ItemPickZones.vue?vue&type=script&lang=js"

import "./ItemPickZones.vue?vue&type=style&index=0&id=486efd3e&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486efd3e"]])

export default __exports__